import { useCallback, useState } from 'react';
import { readPref, writePref } from './storage.js';

export type ThemePref = 'system' | 'light' | 'dark';
const THEME_KEY = 'iptv.panel.theme';

function apply(pref: ThemePref) {
  if (pref === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = pref;
}

export function initTheme(): void {
  const stored = readPref(THEME_KEY);
  apply(stored === 'light' || stored === 'dark' ? stored : 'system');
}

/** [current preference, cycle system→dark→light, set a specific preference]. */
export function useTheme(): [ThemePref, () => void, (pref: ThemePref) => void] {
  const [pref, setPref] = useState<ThemePref>(() => {
    const s = readPref(THEME_KEY);
    return s === 'light' || s === 'dark' ? s : 'system';
  });
  const set = useCallback((next: ThemePref) => {
    writePref(THEME_KEY, next);
    apply(next);
    setPref(next);
  }, []);
  const cycle = useCallback(() => {
    setPref((p) => {
      const next: ThemePref = p === 'system' ? 'dark' : p === 'dark' ? 'light' : 'system';
      writePref(THEME_KEY, next);
      apply(next);
      return next;
    });
  }, []);
  return [pref, cycle, set];
}
